@if (media) {
<atx-image
  (click)="onImageClick(media.url)"
  class="w-100"
  [class.hidden-preserve-space]="spinning"
  [imageUrl]="media.url"
  failedLoadIconSize="5x"
  [fallbackImageUrl]="fallbackImageUrl"
  [objectFit]="objectFit"
  [maxWidth]="maxWidth"
  [imageBreakpoints]="imageBreakpoints"
>
</atx-image>
<atx-image-360-icon
  class="image-360-icon"
  (click)="spinningClick($event)"
></atx-image-360-icon>
@for (url of media.urls; track url; let i = $index) {
<atx-image
  (click)="onImageClick(media?.urls[currentImageIndex])"
  class="w-100 hidden"
  [class.visible]="i === currentImageIndex"
  [imageUrl]="url"
  failedLoadIconSize="5x"
  [fallbackImageUrl]="fallbackImageUrl"
  [objectFit]="objectFit"
  [maxWidth]="maxWidth"
  [imageBreakpoints]="imageBreakpoints"
>
</atx-image>
} }
